export const GetAliURL = url => {
  return url;
  // return `https://serv.vfulfill.io/aff_c?offer_id=6814&aff_id=94774&aff_sub=Rishab&url=${encodeURIComponent(
  //   `https://s.click.aliexpress.com/deep_link.htm?aff_short_key=BHdg6fe&dl_target_url=${encodeURIComponent(
  //     url
  //   )}%3Faf={affiliate_ref}&cn={offer_id}&cv={offer_url_id}&dp={transaction_id}`
  // )}`;
};
